import Swal from "sweetalert2"
import carboneSDK from 'carbone-sdk-js'
import somaticService from "../service/somatic"
import axios from "axios"

export const generateReport = async (type = 'pdf', reportPayload,snvSelectedTableDatas = [],svSelectedTableDatas = [],fusionSelectedTableDatas = [],id) => {
    const _carboneService = carboneSDK(
      'eyJhbGciOiJFUzUxMiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiI3MjIyMTU0MzI3NTgxMTY2MzkiLCJhdWQiOiJjYXJib25lIiwiZXhwIjoyMzU3ODEwNDYyLCJkYXRhIjp7InR5cGUiOiJwcm9kIn19.ASss8BruqhOwcUx3kQZvnKWVZdmUcyaDEeRmokkLqqSEsOE-mriBuwlw8V8yEHiW-eIo_eNYhO_NT_ZS0A0vkJ32Ab5q2kvT3UusqFuiUEpkpOHE5-Ebs-AACTpFnfOERlAbYut4dXczq_eHnYOhOuRCc0_oI1lKJKf4yI0BEoems1Y5'
    )
    try {
    //   if (
    //     !reportPayload.name ||
    //     !reportPayload.protocolNo ||
    //     !reportPayload.referralDate ||
    //     !reportPayload.referringCenter ||
    //     !reportPayload.patientName ||
    //     !reportPayload.referringDoctor
    //   ) {
    //     Swal.fire(' Please fill out all fields in the form!', '', 'error')
    //     return
    //   }
      reportPayload.date = Math.floor(Date.now() / 1000)

      var tableRowItem = []
      var contentRowItem = []
      const requestId = id.split('&')

      const somaticDetailReq = await somaticService.getSomaticDetail(requestId[1])
      reportPayload.clinicalDiagnosis = somaticDetailReq.data.clinicalDiagnosis
      reportPayload.collectionDate = somaticDetailReq.data.collectionDate
      reportPayload.receivedDate = somaticDetailReq.data.receivedDate
      reportPayload.panelType = somaticDetailReq.data.panelType
      reportPayload.dataType = somaticDetailReq.data.dataType
      reportPayload.specimenType = somaticDetailReq.data.specimenType
      reportPayload.specimenSite = somaticDetailReq.data.specimenSite
      reportPayload.loh = 'N/A'
      // reportPayload.loh = somaticDetailReq.data.somaticInfo.lohPercentage
      reportPayload.tmbLevel = somaticDetailReq.data?.somaticInfo?.tmbValue?.toFixed(2) + ' Muts/MB'
      if (somaticDetailReq.data?.somaticInfo?.msiTotalNumberOfSites > 230) {
        reportPayload.msiLevel =
          somaticDetailReq.data?.somaticInfo?.msiTotalNumberOfSites +
          ',' +
          somaticDetailReq.data?.somaticInfo?.msiValue
      } else {
        reportPayload.msiLevel = 'Undeterminable'
      }
      reportPayload.tmbTitle = 'Tumor Mutational Burden (TMB) '

      if (parseFloat(somaticDetailReq.data?.somaticInfo?.tmbValue).toFixed(2) > 200) {
        reportPayload.tmbScore = 'High TMB'
        reportPayload.tmbDesc =
          'Microsatellite instability (MSI) testing and tumor mutational burden (TMB) are genomic biomarkers used to identify patients who are likely to benefit from immune checkpoint inhibitors. Pembrolizumab was recently approved by the Food and Drug Administration for use in TMB-high (TMB-H) tumors, regardless of histology, based on KEYNOTE-158. The primary objective of this retrospective study was real-world applicability and use of immunotherapy in TMB/MSI-high patients to lend credence to and refine this biomarker.       '
      } else {
        reportPayload.tmbScore = 'Low TMB'
      }

      let arrays = [...snvSelectedTableDatas, ...svSelectedTableDatas, ...fusionSelectedTableDatas]
      await arrays.reduce(async (a, item) => {
        await a
        var contentRowData
        var oncoReq
        var tableRowData
        if ('SVType' in item) {
          oncoReq = await somaticService.getSelectedOncokbDatasSVandFusion(
            item.OncoKBGene,
            item.OncoKBGene,
            item.OncoKBSVType,
            'false'
          )
          tableRowData = {
            Ref_Gene: item.OncoKBGene,
            txChange: 'N/A',
            CanverVar: 'N/A',
            DET: 'N/A',
            VAF: 'N/A',
          }
          contentRowData = {
            columns: {
              first: item.OncoKBGene,
              second: '',
              third: item.OncoKBSVType,
              fourth: '',
              fifth: '',
            },
            Ref_Gene: item.OncoKBGene,
            geneSummary: oncoReq.data.geneSummary,
            variantSummary: oncoReq.data.variantSummary,
            highestLevel: item.HighestLevel,
            description: oncoReq?.data?.mutationEffect?.description
              ? oncoReq?.data?.mutationEffect?.description
              : ' Null ',
            svType: true,
          }
        } else if ('Fusion' in item) {
          oncoReq = await somaticService.getSelectedOncokbDatasSVandFusion(
            item.Fusion.split('-')[0],
            item.Fusion.split('-')[1],
            'FUSION',
            'true'
          )
          tableRowData = {
            Ref_Gene: item.Fusion,
            txChange: 'N/A',
            CanverVar: 'N/A',
            DET: 'N/A',
            VAF: 'N/A',
          }
          contentRowData = {
            columns: {
              first: item.Fusion,
              second: '',
              third: 'FUSION',
              fourth: '',
              fifth: '',
            },
            Ref_Gene: item.Fusion,
            geneSummary: oncoReq.data.geneSummary,
            variantSummary: oncoReq.data.variantSummary,
            highestLevel: item.HighestLevel,
            description: oncoReq.data.mutationEffect.description,
            svType: true,
            fusion: true,
          }
        } else {
          var vaf = parseFloat(item.AF) * 100
          var genomicLocation =
            item.Chrom + ',' + item.Start + ',' + item.End + ',' + item.Ref + ',' + item.Alt
          oncoReq = await somaticService.getSelectedOncokbDatasSNV(genomicLocation)
          var finding =
            item.txChange && item.aaChange === null
              ? 'N/A'
              : item.txChange + '(' + item.aaChange + ')'
          tableRowData = {
            Ref_Gene: item.Gene_refGene,
            finding: finding,
            lod: item.DET + '(' + item.DETS + ')',
            CanverVar: item.CancerVar_Tier,
            canverVarEVS: item.CancerVar_Evidence,
            DET: item.DET,
            DETS: item.DETS,
            VAF: vaf.toFixed(1) + ' % ',
          }
          contentRowData = {
            columns: {
              first: item.Gene_refGene,
              second: 'Request',
              third: item.txChange,
              fourth: item.aaChange,
              fifth: vaf.toFixed(1) + ' % ',
            },
            Ref_Gene: item.Gene_refGene,
            txChange: item.txChange,
            aaChange: item.aaChange,
            CanverVar: item.CancerVar_Tier,
            DET: item.DET,
            DETS: item.DETS,
            VAF: parseFloat(item.AF) * 100 + ' % ',
            highestLevel: item.HighestLevel,
            geneSummary: oncoReq.data.geneSummary,
            variantSummary: oncoReq.data.variantSummary,
            CanverVarTierEvs:
              '<b> Variant Interpretation: </b>' +
              item.CancerVar_Tier +
              '(' +
              item.CancerVar_Evidence +
              ')',
            variantInterpretation: 'Variant Interpretation:' + item.CancerVar_and_Evidence,
            description: oncoReq.data.mutationEffect.description
              ? oncoReq.data.mutationEffect.description
              : ' Null ',
          }
        }
        var getSymbol
        var getSymbol2
        var symbol1
        var symbol2
        if (contentRowData.fusion === true) {
          getSymbol = await axios
            .get(`https://rest.ensembl.org/lookup/symbol/homo_sapiens/${item.Fusion.split('-')[0]}`)
            .then((response) => {
              symbol1 = response.data.id
            })
            .catch((error) => {
              symbol1 = item.Fusion.split('-')[0]
            })
          getSymbol2 = await axios
            .get(`https://rest.ensembl.org/lookup/symbol/homo_sapiens/${item.Fusion.split('-')[1]}`)
            .then((response) => {
              symbol2 = response.data.id
            })
            .catch((error) => {
              symbol2 = item.Fusion.split('-')[1]
            })
          contentRowData.columns.second = symbol1 + '-' + symbol2
        } else {
          getSymbol = await axios.get(
            `https://rest.ensembl.org/lookup/symbol/homo_sapiens/${contentRowData.columns.first}`
          )
          contentRowData.columns.second = getSymbol.data.id
        }

        if (item.HighestLevel === 'LEVEL_2' || item.HighestLevel === 'LEVEL_1') {
          tableRowData.highestLevel = 'Yes'
        } else {
          tableRowData.highestLevel = 'No'
        }

        if (item.HighestLevel === 'LEVEL_1') {
          contentRowData.color = '#549b4e'
        } else if (item.HighestLevel === 'LEVEL_2') {
          contentRowData.color = '#1f78b6'
        } else if (item.HighestLevel === 'LEVEL_3A') {
          contentRowData.color = '#984ea3'
        } else if (item.HighestLevel === 'LEVEL_3B') {
          contentRowData.color = '#be98d0'
        } else if (item.HighestLevel === 'LEVEL_4') {
          contentRowData.color = '#424242'
        } else if (item.HighestLevel === 'LEVEL_Dx1') {
          contentRowData.color = '#35a12c'
        } else if (item.HighestLevel === 'LEVEL_Dx2') {
          contentRowData.color = '#1f78b6'
        } else if (item.HighestLevel === 'LEVEL_Dx3') {
          contentRowData.color = '#984ea3'
        } else if (item.HighestLevel === 'LEVEL_Px1') {
          contentRowData.color = '#35a12c'
        } else if (item.HighestLevel === 'LEVEL_Px2') {
          contentRowData.color = '#1f78b6'
        } else if (item.HighestLevel === 'LEVEL_Px3') {
          contentRowData.color = '#984ea3'
        } else if (item.HighestLevel === 'LEVEL_R1') {
          contentRowData.color = '#f03523'
        } else if (item.HighestLevel === 'LEVEL_R2') {
          contentRowData.color = '#f99a92'
        } else {
          contentRowData.color = '#000000'
        }
        let drugsDesc = []
        let alterations = ''
        let drugsStr = ''
        if (oncoReq.status === 200) {
          oncoReq.data.treatments?.forEach((drugItem) => {
            drugItem.drugs?.forEach((drug) => {
              drugsStr += drug.drugName + ','
            })
            let drugArray = drugsStr.split(',').map((drug) => drug.trim())

            let uniqueDrugsSet = new Set(drugArray)
            let uniqueDrugsArray = Array.from(uniqueDrugsSet)

            drugsDesc.push({
              description: drugItem.description,
              cancerType: drugItem.levelAssociatedCancerType.mainType.name,
              drugTitle: uniqueDrugsArray.join(' + ').slice(0, -2),
            })
            drugItem.alterations?.forEach((alteration) => {
              alterations += alteration + ','
            })
          })
        }
        if (contentRowData.svType === true) {
          let alterationsArray = alterations.split(',').map((drug) => drug.trim())
          let uniqueAlterationsSet = new Set(alterationsArray)
          let uniqueAlterationsArray = Array.from(uniqueAlterationsSet)
          contentRowData.columns.fourth = uniqueAlterationsArray.join(' , ').slice(0, -2)
        }

        let drugArray = drugsStr.split(',').map((drug) => drug.trim())

        let uniqueDrugsSet = new Set(drugArray)
        let uniqueDrugsArray = Array.from(uniqueDrugsSet)

        tableRowData.drugNames = uniqueDrugsArray.join(', ')
        contentRowData.drugNames = uniqueDrugsArray.join(' + ').slice(0, -2)
        const uniqueDescriptions = [...new Set(drugsDesc.map((item) => item.description))]

        const newData = uniqueDescriptions.map((description) =>
          drugsDesc.find((item) => item.description === description)
        )
        // var uniqueArray = [...new Set(drugsDesc)]
        contentRowData.drugsDesc = newData
        contentRowItem.push(contentRowData)
        tableRowItem.push(tableRowData)
      }, Promise.resolve())

      reportPayload.testContent =
        'Agilent SureSelect Cancer CGP Assay, a targeted, pan-cancer panel based on hybridization capture and the next generation sequencing technology, enables running two parallel assays; 679  genes on DNA level and 80 genes on RNA level associated to solid cancers are analysed in this test for detecting different types of variations, including single nucleotide variants (SNV), copy number variations (CNV), small insertions and deletions (Indel), translocations (TLs). Immuno-oncology biomarkers like Tumora Mutational Burden and Microsatellite Instability (MSI) and RNA gene fusions are also covered. Please see https://rb.gy/o3sg9. '
      reportPayload.oncoTable = tableRowItem
      reportPayload.oncoDesc = contentRowItem
      console.log(reportPayload)
      try {
        _carboneService
          .render('b3c32c5c46f38d29f22f504f320bf554e8cdc5e315224746d33bf1cca2772a09', {
            data: reportPayload,
            convertTo: type,
          })
          .then((res) => {
            var link = window.document.createElement('a')
            link.href = window.URL.createObjectURL(res.content)
            link.download = link.href.split('/').pop() + '.' + type
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          })
      } catch (error) {
        console.log('json is not valid')
      }
    } catch (error) {
      console.log('something went wrong', error)
    }
    // setIsLoadingReport(false)
  }
